import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV, TREATMENTS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-[color:var(--na-section)] border-t border-[color:var(--na-border)]" data-testid="site-footer">
      <div className="na-container py-16 grid gap-12 lg:grid-cols-4">
        <div>
          <img src={SITE.logo} alt={SITE.name} className="h-16 w-auto object-contain mb-4" />
          <p className="text-sm text-[color:var(--na-muted)] leading-relaxed max-w-xs">
            {SITE.subtag}
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href={SITE.socials.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center border border-[color:var(--na-border)] hover:bg-[color:var(--na-teal)] hover:text-white hover:border-[color:var(--na-teal)] transition" aria-label="Instagram" data-testid="footer-instagram">
              <Instagram size={16} />
            </a>
            <a href={SITE.socials.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center border border-[color:var(--na-border)] hover:bg-[color:var(--na-teal)] hover:text-white hover:border-[color:var(--na-teal)] transition" aria-label="Facebook" data-testid="footer-facebook">
              <Facebook size={16} />
            </a>
            <a href={SITE.socials.youtube} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center border border-[color:var(--na-border)] hover:bg-[color:var(--na-teal)] hover:text-white hover:border-[color:var(--na-teal)] transition" aria-label="YouTube" data-testid="footer-youtube">
              <Youtube size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-[color:var(--na-muted)] hover:text-[color:var(--na-teal)] transition">
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/book" className="text-[color:var(--na-muted)] hover:text-[color:var(--na-teal)] transition">
                Book Appointment
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {TREATMENTS.slice(0, 8).map((t) => (
              <li key={t.slug}>
                <Link to={`/treatments/${t.slug}`} className="text-[color:var(--na-muted)] hover:text-[color:var(--na-teal)] transition">
                  {t.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[color:var(--na-muted)]">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[color:var(--na-teal)] mt-0.5 shrink-0" />
              <span>
                {SITE.address.line1}<br />
                {SITE.address.line2}<br />
                {SITE.address.line3}<br />
                {SITE.address.city} - {SITE.address.pincode}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[color:var(--na-teal)]" />
              <a href={`tel:${SITE.phone}`} className="hover:text-[color:var(--na-teal)]">{SITE.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[color:var(--na-teal)]" />
              <a href={`mailto:${SITE.email}`} className="hover:text-[color:var(--na-teal)]">{SITE.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[color:var(--na-border)]">
        <div className="na-container py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[color:var(--na-muted)]">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Crafted with care for women's wellness.</p>
        </div>
      </div>
    </footer>
  );
}
